var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "common-xlz" }, [_vm._t("head"), _vm._v(" "), _c('resource-list', { attrs: { "resources": _vm.resources, "frames": _vm.frames }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
        var resource = _ref.resource;
        return [_c('el-image', { style: "width:86px;height:86px;", attrs: { "fit": "contain", "src": resource.thumb_url, "lazy": true }, on: { "mouseenter": function mouseenter($event) {
              return _vm.show(resource.thumb_url);
            }, "mouseleave": _vm.hide } }, [_c('div', { staticClass: "image-slot", attrs: { "slot": "error" }, slot: "error" }, [_c('i', { staticClass: "el-icon-picture-outline" })])])];
      } }, { key: "add-button", fn: function fn(_ref2) {
        var resource = _ref2.resource;
        return [_c('add-resource-to-playable', { attrs: { "resource": resource }, on: { "addResource": _vm.handleAddResource } })];
      } }, { key: "title", fn: function fn(_ref3) {
        var resource = _ref3.resource;
        return [_c('div', { staticClass: "resource-title", attrs: { "title": resource.name } }, [_vm._v("\n        " + _vm._s(resource.name) + "\n      ")])];
      } }]) })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };